import script from "./equipment-certificates.vue?vue&type=script&setup=true&lang=ts"
export * from "./equipment-certificates.vue?vue&type=script&setup=true&lang=ts"

import "./equipment-certificates.vue?vue&type=style&index=0&id=4539489f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4539489f"]])

export default __exports__